import { openDialog, openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import { Sample, SampleSlice } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import { useState } from "react";

function MultipleSlicesForm({
  currentBarcode,
  onChange,
}: {
  currentBarcode: string;
  onChange: (newCount: number, currentBarcode: string) => void;
}) {
  let [count, setCount] = useState(2);
  let [barcode, setBarcode] = useState(currentBarcode);

  return (
    <div className="grid c1 gap10">
      <Input
        name="Nombre de lames"
        value={count}
        shouldFocus={true}
        type="text"
        placeholder="Ex: 20"
        onChange={(newCount) => {
          setCount(newCount);
          onChange(newCount, barcode);
        }}
      />
      <Input
        name="Code barre"
        value={barcode}
        type="text"
        placeholder="Ex: BX0007"
        onChange={(newBarcode) => {
          setBarcode(newBarcode);
          onChange(count, newBarcode);
        }}
      />
    </div>
  );
}

export async function openMultipleSlicesForm({
  sample,
  onSave,
}: {
  sample: Sample;
  onSave: (slices: SampleSlice[]) => void;
}) {
  let count = 0;
  let barcode = sample.barcode?.toString() || "";
  await openDialog({
    title: "Ajouter des lames",
    content: (
      <MultipleSlicesForm
        currentBarcode={barcode}
        onChange={(newCount, newBarcode) => {
          barcode = newBarcode;
          count = newCount;
        }}
      />
    ),
    onConfirm: async () => {
      if (!count) throw new Error("Vous devez entrer un nombre de lames");
      if (!barcode) throw new Error("Vous devez entrer un code barre");
      let slices: SampleSlice[] = [];
      let existingSlices = sample.slices || [];

      for (let i = 1; i < count + 1; i++) {
        const existingSlice = existingSlices.find(
          (slice) => slice?.barcode == `${barcode}-${i}`
        );
        if (existingSlice) {
          slices.push(existingSlice);
          continue;
        }

        slices.push({
          barcode: `${barcode}-${i}`,
          rootBarcode: barcode,
          sampleNumber: i,
          creator: getUserId(),
          location: null,
          sample: getItemId(sample),
          status: "pending",
        });
      }

      await apiFetch("sampleSlices", "addMany", {
        sampleId: getItemId(sample),
        sampleSlices: slices,
      });

      onSave(slices);
    },
  });
}
